import { Card, Fade, Icon, Modal } from "@mui/material";
import errorIcon from "assets/images/icons/error.png";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";
import { UserContext } from "context/user";
import PropTypes from "prop-types";
import { useContext, useEffect, useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "70%", md: "50%", lg: "40%", xl: "30%" },
  p: 3,
};

export default function ModalNewLogin({ open, data, openTime }) {
  const [timeLeft, setTimeLeft] = useState(30);
  const { logout } = useContext(UserContext);

  useEffect(() => {
    if (!openTime) return;

    const interval = setInterval(() => {
      const diff = Math.max(0, 30 - Math.floor((Date.now() - openTime) / 1000));
      setTimeLeft(diff);

      if (diff <= 0) clearInterval(interval);
    }, 1000);

    return () => clearInterval(interval);
  }, [open, openTime]);

  useEffect(() => {
    if (timeLeft <= 0) {
      logout();
    }
  }, [timeLeft, logout]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open && data}
      closeAfterTransition
    >
      <Fade in={open && data} mountOnEnter unmountOnExit>
        <Card sx={style}>
          <SoftBox
            display="flex"
            flexDirection="column"
            gap={2}
            alignItems="center"
            justifyContent="center"
            textAlign="center"
          >
            <SoftBox
              component="img"
              src={errorIcon}
              alt="Nuevo inicio de sesión"
              width="150px"
              p={3}
            />

            <SoftTypography variant="h6" fontWeight="bold">
              Se ha detectado un nuevo inicio de sesión en su cuenta.
            </SoftTypography>
            <SoftBox display="flex" gap={1} alignItems="center">
              <Icon>devices</Icon>
              <SoftTypography variant="caption" fontWeight="bold">
                Dispositivo:{" "}
                {data?.dispositivo !== "Desconocido"
                  ? `${data?.dispositivo} (${data?.sistemaOperativo} ${data?.versionSistemaOperativo})`
                  : data?.sistemaOperativo
                  ? `${data?.sistemaOperativo} ${data?.versionSistemaOperativo}`
                  : "Desconocido"}
              </SoftTypography>
            </SoftBox>
            <SoftBox display="flex" gap={1} alignItems="center">
              <Icon>location_on</Icon>
              <SoftTypography variant="caption" fontWeight="bold">
                Ubicación: {data?.ciudad ? `${data?.ciudad} (${data?.pais})` : "Desconocido"}
              </SoftTypography>
            </SoftBox>
            <SoftTypography variant="h6" fontWeight="bold">
              Esta sesión se cerrará automaticamente en {timeLeft} segundos.
            </SoftTypography>
            <SoftTypography variant="caption" fontWeight="light">
              Si no ha sido usted, por favor <strong>cambie su contraseña inmediatamente</strong> y
              reporte el incidente a Recursos Humanos.
            </SoftTypography>
          </SoftBox>

          <SoftBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            pt={3}
            gap={2}
            flexDirection={{ xs: "column", md: "row" }}
          >
            <SoftButton variant="gradient" color="dark" circular fullWidth onClick={logout}>
              <Icon>logout</Icon>&nbsp; Salir
            </SoftButton>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}

ModalNewLogin.propTypes = {
  open: PropTypes.bool.isRequired,
  data: PropTypes.object,
  openTime: PropTypes.number,
};
